export const SURVEY_PAGE_PERMISSIONS = {
  VIEW_GLOBAL: 'campanhas/pesquisa-satisfacao/visualizar/global',
  VIEW_SCOPED: 'campanhas/pesquisa-satisfacao/visualizar/lojas',
  MANAGE_GLOBAL: 'campanhas/pesquisa-satisfacao/gerenciar/global',
  MANAGE_SCOPED: 'campanhas/pesquisa-satisfacao/gerenciar/lojas',
}

/** Any leaf that can open list or results routes (view or manage). */
export const SURVEY_ROUTE_PERMISSIONS_VIEW_ANY = [
  SURVEY_PAGE_PERMISSIONS.VIEW_GLOBAL,
  SURVEY_PAGE_PERMISSIONS.VIEW_SCOPED,
  SURVEY_PAGE_PERMISSIONS.MANAGE_GLOBAL,
  SURVEY_PAGE_PERMISSIONS.MANAGE_SCOPED,
]

/** Any leaf that can open create/edit routes. */
export const SURVEY_ROUTE_PERMISSIONS_MANAGE_ANY = [SURVEY_PAGE_PERMISSIONS.MANAGE_GLOBAL, SURVEY_PAGE_PERMISSIONS.MANAGE_SCOPED]
